import { render, staticRenderFns } from "./arrow-next.vue?vue&type=template&id=5e2535bd&scoped=true&lang=pug&"
import script from "./arrow-next.vue?vue&type=script&lang=js&"
export * from "./arrow-next.vue?vue&type=script&lang=js&"
import style0 from "./arrow-next.vue?vue&type=style&index=0&id=5e2535bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2535bd",
  null
  
)

export default component.exports